<div class="astral-stack-l">
  <h5>{{ 'COMPANY.SETTINGS_VISMA_ROR' | translate }}</h5>
  <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
    <astral-input [control]="form.controls['externalCompany']"></astral-input>
    <astral-input [control]="form.controls['internalCompany']"></astral-input>
    <astral-input [control]="form.controls['senderRoutine']"></astral-input>
    <astral-input [control]="form.controls['senderSubroutine']"></astral-input>
    <astral-input [control]="form.controls['originType']"></astral-input>
    <astral-input [control]="form.controls['processingType']"></astral-input>
    <astral-input [control]="form.controls['fileExtension']"></astral-input>
    <astral-checkbox [control]="form.controls['asymmetricBundling']"></astral-checkbox>
    <astral-checkbox [control]="form.controls['includeTodaysWork']"></astral-checkbox>
  </astral-layout-group>

  <div class="account-parts-table">
    <div class="account-parts-header">
      <span>{{ 'COMPANY.SETTINGS_VISMA_ROR.ACCOUNT_PART' | translate }}</span>
      <span>{{ 'COMPANY.SETTINGS_VISMA_ROR.ACCOUNT_PART_SOURCE' | translate }}</span>
      <span>{{ 'COMPANY.SETTINGS_VISMA_ROR.FIXED_VALUE' | translate }}</span>
      <span>{{ 'COMPANY.SETTINGS_VISMA_ROR.DECLARED_LENGTH' | translate }}</span>
      <span>{{ 'COMPANY.SETTINGS_VISMA_ROR.CHARACTER_TYPE' | translate }}</span>
    </div>
    @for (name of accountPartNames; track name; let index = $index) {
      <div class="account-parts-row" [formGroup]="getAccountPart(name)">
        <strong>KONTO{{ index + 1 }}</strong>
        <astral-select [control]="getAccountPart(name).controls['source']" [itemsSource]="sourceSelection"></astral-select>
        <astral-input [control]="getAccountPart(name).controls['fixedValue']" [hidden]="!isFixedValue(name)"></astral-input>
        <span [hidden]="isFixedValue(name)"></span>
        <astral-input type="number" [control]="getAccountPart(name).controls['declaredLength']"></astral-input>
        <astral-select [control]="getAccountPart(name).controls['characterType']" [itemsSource]="characterTypeSelection"></astral-select>
      </div>
    }
  </div>
</div>
